import { useTranslation } from "react-i18next";

export const Footer = () => {
  const thisYear = new Date(Date.now()).getFullYear();
  const { t } = useTranslation();

  return (
    <div className="footer">
      <p>
        &#169;{thisYear}&nbsp;&nbsp;
        <a
          className="no_pad_links"
          href="https://github.com/PIYatGitHub"
          target="_blank"
          rel="noreferrer"
        >
          Petar Yonkov
        </a>
      </p>
      <p>
        <a href="tel:+35929434783" className="no_pad_links call_us_or_come">
          {t("call_us")}
        </a>
        &nbsp;&nbsp;
        {t("or_w")}
        &nbsp;&nbsp;
        <a
          href="https://www.google.bg/maps/@42.6912406,23.3393636,3a,60.6y,4.53h,85.14t/data=!3m6!1e1!3m4!1sTyNRMIR46AHAizNErbaDNQ!2e0!7i16384!8i8192?hl=en-GB&authuser=0"
          target="_blank"
          rel="noreferrer"
          className="no_pad_links call_us_or_come"
        >
          {t("find_us")}
        </a>
      </p>
    </div>
  );
};
